import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { Modal, Button, FormGroup, Label, P, Textarea, Input, reset, buttonReset, Stack, H, Tabs, theme } from '@raketa-cms/raketa-mir';
import Dropzone from 'react-dropzone';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}
var Img = function Img(_ref) {
  var src = _ref.src,
    variant = _ref.variant,
    className = _ref.className,
    onLoad = _ref.onLoad,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? null : _ref$alt,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? null : _ref$title,
    props = _objectWithoutPropertiesLoose(_ref, ["src", "variant", "className", "onLoad", "alt", "title"]);
  if (!src) {
    console.warn("WARNING: Image with src null or undefined will not be rendered: " + variant + " " + (className || ''));
    return null;
  }
  var imgAlt = alt !== null ? alt : src.alt;
  var imgTitle = title !== null ? title : '';
  if (typeof src === 'object' && !('name' in src)) console.warn("WARNING: Image with empty {}: " + variant + " " + (className || ''));
  if (typeof src === 'object' && 'name' in src && (src.name.includes('.svg') || src.name.includes('.gif'))) return /*#__PURE__*/React.createElement("img", _extends({
    src: src.urls.original,
    alt: imgAlt !== null ? imgAlt : src.name,
    className: className,
    onLoad: onLoad,
    title: imgTitle
  }, props));
  if (typeof src === 'object' && 'name' in src) return /*#__PURE__*/React.createElement("img", _extends({
    src: src.urls[variant],
    alt: imgAlt !== null ? imgAlt : src.name,
    className: className,
    onLoad: onLoad,
    title: imgTitle
  }, props));
  if (typeof src === 'string') return /*#__PURE__*/React.createElement("img", _extends({
    src: src,
    alt: src,
    className: className,
    onLoad: onLoad,
    title: imgTitle
  }, props));
  return null;
};
function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-top: ", ";\n  border-top: 1px solid ", ";\n"]);
  _templateObject2 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  max-height: 75vh;\n  overflow-y: auto;\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
var ModalContent = styled.div(_templateObject());
var ModalFooter = styled.div(_templateObject2(), function (props) {
  return props.theme.font.base;
}, function (props) {
  return props.theme.colors.gray;
});
var Dialog = function Dialog(_ref) {
  var onClose = _ref.onClose,
    title = _ref.title,
    children = _ref.children,
    primaryLabel = _ref.primaryLabel,
    _ref$secondaryLabel = _ref.secondaryLabel,
    secondaryLabel = _ref$secondaryLabel === void 0 ? 'Cancel' : _ref$secondaryLabel,
    onPrimary = _ref.onPrimary;
  return /*#__PURE__*/React.createElement(Modal, {
    title: title,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(ModalContent, null, children), (primaryLabel || secondaryLabel) && /*#__PURE__*/React.createElement(ModalFooter, null, primaryLabel && /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "primary",
    onClick: onPrimary
  }, primaryLabel), secondaryLabel && /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "secondary",
    onClick: onClose
  }, secondaryLabel)));
};
Dialog.defaultProps = {
  children: [],
  dialogSize: ''
};
var removeByIndex = function removeByIndex(items, idx) {
  return [].concat(items.slice(0, idx), items.slice(idx + 1));
};
var removeById = function removeById(items, id, idField) {
  if (idField === void 0) {
    idField = 'id';
  }
  return removeByIndex(items, items.findIndex(function (current) {
    return current[idField] === id;
  }));
};
var randomString = function randomString(length) {
  return Math.random().toString(36).substring(length);
};
var TextField = function TextField(props) {
  var id = randomString();
  var label = props.label,
    hint = props.hint,
    multiline = props.multiline,
    _onChange = props.onChange;
  var inputProps = Object.assign({}, props);
  delete inputProps.label;
  delete inputProps.hint;
  delete inputProps.multiline;
  delete inputProps.onChange;
  var Component = multiline ? Textarea : Input;
  return /*#__PURE__*/React.createElement(FormGroup, null, label ? /*#__PURE__*/React.createElement(Label, {
    htmlFor: id,
    error: props.error
  }, label) : '', /*#__PURE__*/React.createElement(Component, _extends({
    id: id,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    }
  }, inputProps)), hint ? /*#__PURE__*/React.createElement(P, null, hint) : '');
};
var TextInput = function TextInput(_ref) {
  var label = _ref.label,
    onChange = _ref.onChange,
    value = _ref.value,
    placeholder = _ref.placeholder;
  return /*#__PURE__*/React.createElement(TextField, {
    label: label,
    value: value,
    placeholder: placeholder,
    onChange: onChange
  });
};
TextInput.defaultProps = {
  value: '',
  placeholder: ''
};
function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  position: absolute;\n  bottom: 8px;\n  right: 12px;\n  background-color: ", ";\n  font-size: 1em;\n  color: #fff;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  line-height: 19px;\n"]);
  _templateObject5 = function _templateObject5() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  position: absolute;\n  bottom: 8px;\n  left: 12px;\n  background-color: ", ";\n  font-size: 0.85em;\n  color: #fff;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n"]);
  _templateObject4 = function _templateObject4() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  width: 100px;\n  height: 100px;\n  background-color: ", ";\n\n  & > img {\n    width: 100%;\n  }\n"]);
  _templateObject3 = function _templateObject3() {
    return data;
  };
  return data;
}
function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  position: relative;\n  cursor: pointer;\n  width: 116px;\n  height: 116px;\n  border: 8px solid\n    ", ";\n\n  button {\n    display: none;\n  }\n\n  &:hover {\n    button {\n      display: inline-block;\n    }\n  }\n"]);
  _templateObject2$1 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  display: flex;\n  flex-wrap: wrap;\n  align-content: flex-start;\n  margin-top: 1em;\n  min-height: 500px;\n"]);
  _templateObject$1 = function _templateObject() {
    return data;
  };
  return data;
}
var IconEdit = function IconEdit() {
  return /*#__PURE__*/React.createElement("img", {
    style: {
      width: '12px',
      margin: '0 auto'
    },
    src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIyMnB4IiBoZWlnaHQ9IjIycHgiIHZpZXdCb3g9IjAgMCAyMiAyMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5lZGl0LTI8L3RpdGxlPiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4gICAgPGRlZnM+PC9kZWZzPiAgICA8ZyBpZD0iZWRpdC0yIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPiAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMi4wMDAwMDAsIDIuMDAwMDAwKSIgaWQ9IlNoYXBlIiBzdHJva2U9IiNGRkZGRkYiIHN0cm9rZS13aWR0aD0iMiI+ICAgICAgICAgICAgPHBvbHlnb24gcG9pbnRzPSIxMyAwIDE4IDUgNSAxOCAwIDE4IDAgMTMiPjwvcG9seWdvbj4gICAgICAgIDwvZz4gICAgPC9nPjwvc3ZnPg=="
  });
};
var ImageList = styled.div(_templateObject$1(), reset);
var Thumb = styled.div(_templateObject2$1(), reset, function (props) {
  return props.selected ? props.theme.colors.success : 'transparent';
});
var ImageWrapper = styled.div(_templateObject3(), reset, function (props) {
  return props.theme.colors.lighterGray;
});
var EditButton = styled.button(_templateObject4(), reset, buttonReset, function (props) {
  return props.theme.colors.success;
});
var DeleteButton = styled.button(_templateObject5(), reset, buttonReset, function (props) {
  return props.theme.colors.danger;
});
var getPreviewImage = function getPreviewImage(image) {
  var LARGE_FILE_TRESHOLD = 2 * 1024 * 1024;
  if (image.mime_type === 'image/svg+xml' && image.size > LARGE_FILE_TRESHOLD) {
    return LARGE_FILE_PLACEHOLDER;
  }
  return image;
};
var ImageItem = function ImageItem(_ref) {
  var image = _ref.image,
    selected = _ref.selected,
    onSelect = _ref.onSelect,
    onFastSelect = _ref.onFastSelect,
    onDelete = _ref.onDelete,
    onEdit = _ref.onEdit;
  return /*#__PURE__*/React.createElement(Thumb, {
    selected: selected ? 'selected' : '',
    onClick: function onClick() {
      return onSelect(image);
    },
    onDoubleClick: function onDoubleClick() {
      return onFastSelect(image);
    }
  }, /*#__PURE__*/React.createElement(ImageWrapper, {
    title: image.name
  }, /*#__PURE__*/React.createElement(Img, {
    src: getPreviewImage(image),
    variant: "thumb",
    title: image && image.name
  })), /*#__PURE__*/React.createElement(EditButton, {
    type: "button",
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      onEdit(image);
    }
  }, /*#__PURE__*/React.createElement(IconEdit, null)), /*#__PURE__*/React.createElement(DeleteButton, {
    type: "button",
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      onDelete(image);
    }
  }, "\xD7"));
};
var BrowseTab = function BrowseTab(_ref2) {
  var images = _ref2.images,
    q = _ref2.q,
    initialImage = _ref2.selectedImage,
    onFastSelect = _ref2.onFastSelect,
    onSelect = _ref2.onSelect,
    onDelete = _ref2.onDelete,
    onSearch = _ref2.onSearch,
    onSearchTermChange = _ref2.onSearchTermChange,
    onSearchClear = _ref2.onSearchClear,
    onEdit = _ref2.onEdit;
  var _React$useState = React.useState(initialImage),
    selectedImage = _React$useState[0],
    setSelectedImage = _React$useState[1];
  var handleSelectImage = function handleSelectImage(newSelected) {
    setSelectedImage(newSelected);
    onSelect(newSelected);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stack, {
    v: "center",
    h: "flex-start",
    g: "1em"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Search images",
    value: q,
    onChange: function onChange(term) {
      return onSearchTermChange(term);
    }
  }), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "primary",
    onClick: function onClick() {
      return onSearch();
    }
  }, "Search"), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "secondary",
    onClick: function onClick() {
      return onSearchClear();
    }
  }, "Clear")), /*#__PURE__*/React.createElement(ImageList, null, images.map(function (image) {
    return /*#__PURE__*/React.createElement(ImageItem, {
      key: image.id,
      image: image,
      selected: selectedImage.id === image.id,
      onSelect: handleSelectImage,
      onFastSelect: onFastSelect,
      onDelete: onDelete,
      onEdit: onEdit
    });
  })));
};
var LARGE_FILE_PLACEHOLDER = 'data:image/svg+xml;base64,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';
function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 16px;\n"]);
  _templateObject2$2 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  margin-bottom: 16px;\n  height: 350px;\n  color: #666;\n  background-color: #efefef;\n  border: 2px dashed #ddd;\n"]);
  _templateObject$2 = function _templateObject() {
    return data;
  };
  return data;
}
var StyledDropzone = styled.div(_templateObject$2());
var DropzoneLabel = styled.div(_templateObject2$2());
var Dropbox = function Dropbox(_ref) {
  var buttonLabel = _ref.buttonLabel,
    onDrop = _ref.onDrop;
  var dropzoneRef = /*#__PURE__*/React.createRef();
  var handleOpen = function handleOpen() {
    return dropzoneRef.current.open();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledDropzone, null, /*#__PURE__*/React.createElement(Dropzone, {
    ref: dropzoneRef,
    onDrop: onDrop
  }, function (_ref2) {
    var getRootProps = _ref2.getRootProps,
      getInputProps = _ref2.getInputProps;
    return /*#__PURE__*/React.createElement(DropzoneLabel, getRootProps(), /*#__PURE__*/React.createElement(H, {
      size: "large"
    }, "Select files from your computer"), /*#__PURE__*/React.createElement("small", null, "or drag and drop here"), /*#__PURE__*/React.createElement("input", getInputProps()));
  })), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "success",
    onClick: handleOpen,
    style: {
      marginBottom: '1em'
    }
  }, buttonLabel));
};
Dropbox.defaultProps = {
  buttonLabel: 'Select files...'
};
function _templateObject2$3() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-left: 0.5em;\n  height: 2.4em;\n  font-size: 0.85em;\n  line-height: 2.4em;\n  color: #fff;\n  background-color: #4cae4c;\n"]);
  _templateObject2$3 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 2em;\n  background-color: #efefef;\n"]);
  _templateObject$3 = function _templateObject() {
    return data;
  };
  return data;
}
var ProgressWrapper = styled.div(_templateObject$3());
var Progress = styled.div(_templateObject2$3());
var ProgressBar = function ProgressBar(_ref) {
  var total = _ref.total,
    done = _ref.done;
  var progress = 100 / total * done;
  return /*#__PURE__*/React.createElement(ProgressWrapper, null, /*#__PURE__*/React.createElement(Progress, {
    style: {
      width: progress + "%"
    }
  }, done, "/", total));
};
function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  min-height: 400px;\n"]);
  _templateObject$4 = function _templateObject() {
    return data;
  };
  return data;
}
var FileItem = function FileItem(_ref) {
  var file = _ref.file;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, file.name), /*#__PURE__*/React.createElement("span", null, "Completed"));
};
var FileList = function FileList(_ref2) {
  var files = _ref2.files;
  return /*#__PURE__*/React.createElement("div", null, files.map(function (file) {
    return /*#__PURE__*/React.createElement(FileItem, {
      key: file.id,
      file: file
    });
  }));
};
var ImageUploader = styled.div(_templateObject$4());
var UploadTab = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(UploadTab, _React$Component);
  function UploadTab() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = UploadTab.prototype;
  _proto.isUploading = function isUploading() {
    return this.props.filesToUpload !== this.props.filesUploaded;
  };
  _proto.renderProgress = function renderProgress() {
    var _this$props = this.props,
      filesToUpload = _this$props.filesToUpload,
      filesUploaded = _this$props.filesUploaded,
      files = _this$props.files;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ProgressBar, {
      total: filesToUpload,
      done: filesUploaded
    }), /*#__PURE__*/React.createElement(FileList, {
      files: files
    }));
  };
  _proto.render = function render() {
    var _this = this;
    return /*#__PURE__*/React.createElement(ImageUploader, null, !this.isUploading() ? /*#__PURE__*/React.createElement(Dropbox, {
      onDrop: function onDrop(files) {
        return _this.props.onUpload(files);
      },
      buttonLabel: "Select files"
    }) : null, this.isUploading() ? this.renderProgress() : null);
  };
  return UploadTab;
}(React.Component);
var MediaManagerContext = /*#__PURE__*/React.createContext({});
function _templateObject2$4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-bottom: 16px;\n"]);
  _templateObject2$4 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject$5() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-right: 16px;\n\n  & > img {\n    object-fit: contain;\n    width: 100px;\n    height: 100px;\n    background-color: #ddd;\n  }\n"]);
  _templateObject$5 = function _templateObject() {
    return data;
  };
  return data;
}
var ImageWrapper$1 = styled.div(_templateObject$5());
var ImageControl = styled.div(_templateObject2$4());
var ImagePicker = function ImagePicker(_ref) {
  var mediaManagerProps = _ref.mediaManager,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Image' : _ref$label,
    value = _ref.value,
    onChange = _ref.onChange;
  var mediaManager = mediaManagerProps || React.useContext(MediaManagerContext);
  var _React$useState = React.useState(false),
    open = _React$useState[0],
    setOpen = _React$useState[1];
  var _React$useState2 = React.useState({
      selectedImage: value || false,
      filesToUpload: 0,
      filesUploaded: 0,
      images: [],
      files: [],
      q: ''
    }),
    state = _React$useState2[0],
    setState = _React$useState2[1];
  var fetchData = function fetchData(q, callback) {
    var params = q !== '' ? {
      f: {
        name: q
      }
    } : {};
    mediaManager.findAll(function (images) {
      setState(_extends(_extends({}, state), {}, {
        images: images
      }));
      if (callback) callback();
    }, params);
  };
  var handleOpenPicker = function handleOpenPicker() {
    var q = state.q;
    fetchData(q, function () {
      setOpen(true);
    });
  };
  var notifyChange = function notifyChange() {
    if (onChange) onChange(state.selectedImage);
  };
  var handleClearImage = function handleClearImage() {
    setState(_extends(_extends({}, state), {}, {
      selectedImage: false
    }));
    notifyChange();
  };
  var handleSelectImage = function handleSelectImage() {
    setOpen(false);
    notifyChange();
  };
  var handleSearch = function handleSearch(q) {
    fetchData(q);
  };
  var handleSearchTermUpdate = function handleSearchTermUpdate(q) {
    setState(_extends(_extends({}, state), {}, {
      q: q
    }));
  };
  var handleSearchClear = function handleSearchClear() {
    setState(_extends(_extends({}, state), {}, {
      q: ''
    }));
    fetchData('');
  };
  var handleFastSelect = function handleFastSelect(selectedImage) {
    setState(_extends(_extends({}, state), {}, {
      selectedImage: selectedImage
    }));
    setOpen(false);
    notifyChange();
  };
  var handleDeleteImage = function handleDeleteImage(image) {
    if (!confirm('Are you sure? ')) return;
    var images = state.images;
    mediaManager.destroy(image, function (deletedImage) {
      setState(_extends(_extends({}, state), {}, {
        images: removeById(images, deletedImage.id)
      }));
    });
  };
  var handleEditImage = function handleEditImage(image) {
    setState(_extends(_extends({}, state), {}, {
      imageDialogOpen: true,
      editImage: image,
      alt: image.alt || ''
    }));
  };
  var handleUpload = function handleUpload(files) {
    setState(_extends(_extends({}, state), {}, {
      filesToUpload: files.length,
      filesUploaded: 0,
      files: []
    }));
    files.forEach(function (file) {
      mediaManager.uploadFile(file, function (response) {
        var files = state.files,
          q = state.q;
        setState(_extends(_extends({}, state), {}, {
          filesUploaded: state.filesUploaded + 1,
          files: [].concat(files, [response])
        }));
        if (state.filesToUpload === state.filesUploaded) {
          fetchData(q);
        }
      });
    });
  };
  var filesToUpload = state.filesToUpload,
    filesUploaded = state.filesUploaded,
    images = state.images,
    selectedImage = state.selectedImage,
    files = state.files,
    q = state.q;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImageControl, null, value && /*#__PURE__*/React.createElement(ImageWrapper$1, null, /*#__PURE__*/React.createElement(Img, {
    src: value,
    variant: "thumb",
    title: value.name
  })), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, null, label + " " + (selectedImage.alt ? "(" + selectedImage.alt + ")" : '')), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "secondary",
    onClick: handleOpenPicker
  }, "Browse..."), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "secondary",
    onClick: handleClearImage
  }, "Clear"))), open && /*#__PURE__*/React.createElement(Dialog, {
    open: true,
    onClose: function onClose() {
      return setOpen(false);
    },
    title: "Image Browser",
    primaryLabel: "Select",
    onPrimary: handleSelectImage
  }, /*#__PURE__*/React.createElement(Tabs, null, /*#__PURE__*/React.createElement("div", {
    title: "Browse"
  }, /*#__PURE__*/React.createElement(BrowseTab, {
    images: images,
    selectedImage: selectedImage,
    q: q,
    onSearch: function onSearch() {
      return handleSearch(q);
    },
    onSearchTermChange: handleSearchTermUpdate,
    onSearchClear: handleSearchClear,
    onSelect: function onSelect(selectedImage) {
      return setState(_extends(_extends({}, state), {}, {
        selectedImage: selectedImage
      }));
    },
    onFastSelect: handleFastSelect,
    onDelete: handleDeleteImage,
    onEdit: handleEditImage
  })), /*#__PURE__*/React.createElement("div", {
    title: "Upload"
  }, /*#__PURE__*/React.createElement(UploadTab, {
    filesToUpload: filesToUpload,
    filesUploaded: filesUploaded,
    files: files,
    onUpload: handleUpload
  })))));
};
var ImageInput = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ImageInput, _React$Component);
  function ImageInput(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      selectedImage: props.image || false
    };
    return _this;
  }
  var _proto = ImageInput.prototype;
  _proto.handleChange = function handleChange(selectedImage) {
    var _this2 = this;
    this.setState({
      selectedImage: selectedImage
    }, function () {
      if (_this2.props.onChange) _this2.props.onChange(selectedImage);
    });
  };
  _proto.render = function render() {
    var _this3 = this;
    var _this$props = this.props,
      name = _this$props.name,
      mediaManager = _this$props.mediaManager;
    var selectedImage = this.state.selectedImage;
    return /*#__PURE__*/React.createElement(ThemeProvider, {
      theme: theme
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
      mediaManager: mediaManager,
      value: selectedImage,
      onChange: function onChange(selectedImage) {
        return _this3.handleChange(selectedImage);
      }
    }), /*#__PURE__*/React.createElement("input", {
      type: "hidden",
      name: name,
      value: selectedImage ? selectedImage.id : ''
    })));
  };
  return ImageInput;
}(React.Component);
var imgageSrc = function imgageSrc(src, variant) {
  if (typeof src === 'object' && !('name' in src)) console.warn("WARNING: Image with empty {}: " + variant);
  if (typeof src === 'object' && 'name' in src && (src.name.includes('.svg') || src.name.includes('.gif'))) return src.urls.original;
  if (typeof src === 'object' && 'name' in src) return src.urls[variant];
  if (typeof src === 'string') return src;
  return null;
};
var imgPlaceholder = function imgPlaceholder(size) {
  return "https://placeholder.raketa.cloud/images/" + size;
};
var serialize = function serialize(params) {
  return Object.keys(params).map(function (k) {
    return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
  }).join('&');
};
var get = function get(url, params, opts) {
  if (params === void 0) {
    params = {};
  }
  if (opts === void 0) {
    opts = {};
  }
  return fetch(url + "?" + serialize(params), opts);
};
var patch = function patch(url, params, opts) {
  if (params === void 0) {
    params = {};
  }
  if (opts === void 0) {
    opts = {};
  }
  return fetch(url, Object.assign({
    method: 'PATCH',
    credentials: 'same-origin',
    body: JSON.stringify(params)
  }, opts));
};
var post = function post(url, params, opts) {
  if (params === void 0) {
    params = {};
  }
  if (opts === void 0) {
    opts = {};
  }
  return fetch(url, Object.assign({
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify(params)
  }, opts));
};
var del = function del(url, params, opts) {
  if (params === void 0) {
    params = {};
  }
  if (opts === void 0) {
    opts = {};
  }
  return fetch(url, Object.assign({
    method: 'DELETE',
    credentials: 'same-origin',
    body: JSON.stringify(params)
  }, opts));
};
var MediaManager = /*#__PURE__*/function () {
  function MediaManager(baseUrl) {
    this.baseUrl = baseUrl;
  }
  var _proto = MediaManager.prototype;
  _proto.findAll = function findAll(callback, params) {
    if (params === void 0) {
      params = {};
    }
    get(this.baseUrl + "images", _extends(_extends({}, params), {}, {
      page_size: 100
    })).then(function (r) {
      return r.json();
    }).then(function (images) {
      return callback(images);
    });
  };
  _proto.uploadFile = function uploadFile(file, callback) {
    var body = new FormData();
    body.append('image[asset]', file);
    post(this.baseUrl + "images", {}, {
      body: body
    }).then(function (r) {
      return r.json();
    }).then(function (image) {
      return callback(image);
    });
  };
  _proto.update = function update(image, params, callback) {
    patch(this.baseUrl + "images/" + image.id, {
      image: params
    }, {
      headers: {
        'content-type': 'application/json'
      }
    }).then(function (r) {
      return r.json();
    }).then(function (image) {
      return callback(image);
    });
  };
  _proto.destroy = function destroy(image, callback) {
    del(this.baseUrl + "images/" + image.id, {}, {
      headers: {
        'content-type': 'application/json'
      }
    }).then(function (r) {
      return r.json();
    }).then(function (image) {
      return callback(image);
    });
  };
  return MediaManager;
}();
export { ImageInput, ImagePicker, Img, MediaManager, MediaManagerContext, imgPlaceholder as imagePlaceholder, imgageSrc as imageSrc };